import { NumberUtils } from '@pk/powerkioskutils';

/**
 * System-wide settings loaded from the `settings` GraphQL query by SystemSettingsService. Kept dependency-free
 * so validators and static helpers can read them synchronously.
 */
export class SystemSettings {
	/** The API's `file-max-size` setting, in bytes - the API's own fallback until the setting loads. */
	public static fileMaxSizeBytes = 15000000;

	/** e.g. `14.3 MB` */
	public static get fileMaxSizeLabel(): string {
		return `${NumberUtils.round(NumberUtils.bytesToMegabytes(SystemSettings.fileMaxSizeBytes), 1)} MB`;
	}
}
